import Joyride, { CallBackProps } from 'react-joyride';
import { layerIndex } from '@/modules/theme';
import { DASHBOARD_TOUR_STEPS } from './dashboardTourSteps';
import { CmsTourTooltip } from './CmsTourTooltip';

// Joyride sets its card 100 over its scrim, over toasts too; this sets it one over (spread in, as Joyride's styles type leaves floaterStyles out)
const cardLayer = () => ({ floaterStyles: { options: { zIndex: layerIndex('lureo-layer-tour') + 1 } } });

export function CmsDashboardTour({
  run,
  steps,
  onCallback
}: {
  run: boolean;
  steps: typeof DASHBOARD_TOUR_STEPS;
  onCallback: (data: CallBackProps) => void;
}) {
  return (
    <Joyride
      run={run}
      steps={steps}
      callback={onCallback}
      tooltipComponent={CmsTourTooltip}
      showSkipButton
      spotlightClicks={false}
      disableOverlayClose
      scrollToFirstStep
      locale={{ skip: 'Skip' }}
      styles={{
        ...cardLayer(),
        options: {
          arrowColor: 'transparent',
          backgroundColor: 'transparent',
          overlayColor: 'color-mix(in oklab, var(--lureo-shade) 80%, transparent)', // theme-exempt: Joyride takes its scrim as a colour, not a class: the dialogs' shade and strength (SCRIM)
          primaryColor: 'transparent',
          textColor: 'inherit',
          zIndex: layerIndex('lureo-layer-tour')
        },
        spotlight: { borderRadius: 'var(--lureo-radius-lg)' },
        spotlightLegacy: { borderRadius: 'var(--lureo-radius-lg)' }
      }}
    />
  );
}
